import { createSelector } from "reselect";

const locale = ({ app }) => app.locale;

export const selectTag = createSelector(
  [locale],
  (locale) => locale[0]?.attributes?.tag,
);
